import React,
{
    useEffect,
    useState
}
from "react";

import {
    getRecentClicks
}
from "../services/shortLinkService";

export default function RecentActivityTable({
    currentUser
}) {

    const [clicks,
           setClicks] =
        useState([]);

    const [loading,
           setLoading] =
        useState(true);

    useEffect(() => {

        async function loadData() {

            try {

                const data =
                    await getRecentClicks(
                        currentUser
                    );

                setClicks(
                    data.clicks || []
                );

            }

            catch (err) {

                console.error(
                    err
                );

            }

            finally {

                setLoading(
                    false
                );

            }

        }

        if (
            currentUser
        ) {

            loadData();

        }

    }, [currentUser]);

    if (loading) {

        return (

            <div className="linkTableCard">

                Loading recent activity...

            </div>

        );

    }

    return (

        <div className="RecentActivityCard">

            <h2 className = "statsInfo">

                Recent ShortLink Activity

            </h2>

            <div
                className="recentActivityWrapper"
            >

                <table
                    className="linkTable"
                >

                    <thead>

                        <tr>

                            <th>
                                Time
                            </th>

                            <th>
                                Code
                            </th>

                            <th>
                                Title
                            </th>

                            <th>
                                Source
                            </th>

                            <th>
                                IP
                            </th>

                            <th>
                                Referrer
                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        {

                            clicks.map(
                                click => {

                                    const timestamp =
                                        click.timestamp?._seconds
                                            ?

                                            new Date(
                                                click.timestamp._seconds * 1000
                                            ).toLocaleString()

                                            :

                                            "";

                                    return (

                                        <tr
                                            key={
                                                click.id
                                            }
                                        >

                                            <td>

                                                {timestamp}

                                            </td>

                                            <td>

                                                {
                                                    click.shortCode
                                                }

                                            </td>

                                            <td>

                                                {
                                                    click.linkTitle
                                                }

                                            </td>

                                            <td>

                                                <span
                                                    className={
                                                        click.source === "qr"
                                                            ? "sourceQr"
                                                            : "sourceDirect"
                                                    }
                                                >

                                                    {click.source}

                                                </span>

                                            </td>

                                            <td>

                                                {
                                                    click.ip
                                                }

                                            </td>

                                            <td>

                                                {
                                                    click.referrer ||
                                                    "Direct"
                                                }

                                            </td>

                                        </tr>

                                    );

                                }
                            )

                        }

                    </tbody>

                </table>

            </div>

        </div>

    );

}